if(typeof BSS_B2B != undefined) {
  setTimeout(() =>{
    const targetMiniCart = document.querySelector(".cart-drawer-container");
    if (targetMiniCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {

        for (const record of recordList) {
            if (record.target.classList.contains("cart-recommendations")) {
              setTimeout(async() =>{
                  await BSS_B2B.storage.productStorage.load(); 
                  BSS_B2B.cp?.utils?.init();
                  BSS_B2B.td?.utils?.init();
                  BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
              }, 1000)
              
            }
        }
      });
      mutationObserver.observe(targetMiniCart, { childList: true, subtree: true });
    }
  }, 500)
}